/**
 * TypeScript interfaces for AI Search Preview Component
 * Generated from data model specifications
 */

export interface AIPreviewRequest {
  prompt: string;
  session_id: string;
  timestamp: Date;
}

export interface AIResponseMetadata {
  responseTime: number;
  tokenCount?: number;
  confidence?: number;
  sources?: string[];
  generatedAt: Date;
}

export interface AIPreviewResponse {
  content: string;
  streamedContent: string;
  contentType: 'data' | 'tool_use' | 'mcp_ui';
  isComplete: boolean;
  error?: string;
  metadata?: AIResponseMetadata;
}

export interface PreviewDisplayState {
  isVisible: boolean;
  isExpanded: boolean;
  previewLines: string[];
  totalLines: string[];
  isStreaming: boolean;
  streamingCursor: boolean;
  animationState: 'idle' | 'expanding' | 'collapsing';
}

export interface SearchIntegrationState {
  searchQuery: string;
  shouldTriggerAI: boolean;
  lastSearchQuery: string;
  expansionPreference: 'remember' | 'reset';
  isEnabled: boolean;
}

export interface AIPreviewError {
  type:
    | 'network'
    | 'timeout'
    | 'parsing'
    | 'validation'
    | 'quota'
    | 'component';
  message: string;
  details?: string;
  isRetryable: boolean;
  retryAfter?: number;
  timestamp?: Date;
  errorId?: string;
}

export interface AccessibilityState {
  ariaLabel: string;
  ariaLiveRegion: string;
  focusManagement: 'auto' | 'manual';
  reducedMotion: boolean;
  hasKeyboardFocus: boolean;
}

export enum AIPreviewState {
  IDLE = 'idle',
  LOADING = 'loading',
  STREAMING = 'streaming',
  COMPLETE = 'complete',
  ERROR = 'error',
  EMPTY = 'empty',
}

export interface AIStreamingConfig {
  apiEndpoint: string;
  apiKey: string;
  headers: Record<string, string>;
  timeout: number;
  maxRetries: number;
}
